import React from "react";
import AboutRedesign from "../about/components/AboutRedesign";

function Whydomits() {
  return <AboutRedesign missionCtaTo="/about" />;
}

export default Whydomits;
